import { AboutMe } from './AboutMe';

export default AboutMe;
